import axios from 'axios'
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader'
import React, { useEffect, useState } from 'react'

import AuthWrapper from 'NewComponents/Wrappers/AuthWrapper'
import { useLocation, useNavigate } from 'react-router-dom'
import Button from 'Pages/LoginPage/Button'

const ShortcutPage = () => {
    const [errorMessage, setErrorMessage] = useState(null)

    const REACT_APP_TC_AUTH = process.env.REACT_APP_TC_AUTH
    const navigate = useNavigate();
    const location = useLocation()
    const navigateToLogin = () => {
        navigate("/login");
    };
    useEffect(() => {
        if (location.pathname.split('/s/').length < 2) {
            return (window.location.href = '/')
        }
        const code = location.pathname.split('/s/')[1]
        if (code) {
            const apiUrl = `${REACT_APP_TC_AUTH}/r/${code}`
                ; (async () => {
                    try {
                        const response = await axios.get(apiUrl, {
                            maxRedirects: 0, // don’t auto-follow
                            validateStatus: status => status >= 200 && status < 400, // allow 3xx
                        })
                        if (response.data.dataModel) {
                            window.location.href = response.data.dataModel
                        }
                    } catch (error) {
                        setErrorMessage(
                            error?.response?.data?.responseMessage ?? 'Invalid URL'
                        )
                    }
                })()
        }
    }, [location.pathname, REACT_APP_TC_AUTH])

    if (errorMessage)
        return (
            <AuthWrapper
                heading="Expired"
                subheading={errorMessage || 'Your password reset link has expired. For security, please request a fresh link.'}
            >
                <div className="max-w-md mx-auto mt-10">
                    <div className="space-y-6">
                        <Button onClick={navigateToLogin} variant="primary" fullWidth >
                            Back to Login
                        </Button>
                    </div>
                </div>
            </AuthWrapper>
        )

    return <FullPageLoader />
}

export default ShortcutPage
